import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useStoreon } from "storeon/react";
import { Button } from "@material-ui/core";

import t from "translations";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import ProboOptions from "comp/productselector/probo/Options";

import confirm from "components/Dialog";
import { useProboSize } from "utils/probo";
import { useBackendPrice } from "utils/price";

import { Summery } from "comp/productselector/Summery";
import { Title } from "comp/productselector/ProductsList";
import { DeskpadOptions } from "comp/productselector/DeskpadOptions";


const BackToProducts = styled(Button)({
  display: "none",
  marginRight: 10,
  svg: {
    fontSize: 15,
    verticalAlign: "text-top",
  },
  "@media screen and (max-width: 480px)": {
    display: "inline",
  },
});


const Details = styled.div(({ show }) => ({
  padding: show ? 10 : 0,
  minHeight: 400,
  background: "#f1f1f1",
  width: show ? 450 : 0,
  minWidth: show ? 450 : 0,
  display: "flex",
  maxHeight: "100%",
  overflowY: "auto",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "space-between",
  position: "relative",
  // transition: "all 0.2s ease-in-out",
  b: {
    fontWeight: 900,
  },
  "@media screen and (max-width: 480px)": {
    maxHeight: "none",
    minHeight: "100vh",
    minWidth: 0,
  },
}));

const Params = styled.div({
  padding: 10,
  background: "#fff",
  marginTop: 10,
});

const Header = styled.div({
  ">div": {
    display: "flex",
    flexDirection: "row",
  },
  img: {
    marginBottom: 10,
    marginRight: 10,
    width: 100,
    height: 100,
    objectFit: "cover",
    objectPosition: "top",
  },
});

const ProductDescription = styled.div({
  maxHeight: 140,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  ">span": {
    fontSize: 12,
    color: "#666",
  },
  ">b": {
    fontSize: 18,
    fontWeight: 900,
  },
});

const ProductPrice = ({ product }) => {
  const { total, sqm } = useBackendPrice();
  if (!product || product.proboProduct) {
    return null;
  }
  if (product.price.type === "fixed") {
    if (total) {
      return `${total}€`;
    }
  } else {
    if (sqm) {
      return (
        <>
          {sqm}/m
          <sup>2</sup>
        </>
      );
    }
  }
  return null;
};

export const ProductDetails = ({
  show,
  activeProduct,
  selectedProduct,
  selectProduct,
  productVariations,
  onProductUnselected,
}) => {
  const proboSize = useProboSize();
  const {
    dispatch,
    products,
    canvas,
    productOptions,
    proboCodes,
    proboUploader,
    contentType,
  } = useStoreon(
    "product",
    "products",
    "canvas",
    "isProductSelectorOpened",
    "productOptions",
    "proboCodes",
    "proboUploader",
    "contentType"
  );

  const variantLabel = activeProduct?.attributes
    ? Object.entries(activeProduct?.attributes).reduce(
        (label, [name, val]) => `${label} ${val}`,
        ""
      )
    : "- - -";

  return (
    <Details show={show}>
      <div>
        <Header>
          <Title>
            <BackToProducts
              startIcon={<ArrowBackIosIcon />}
              variant="outlined"
              onClick={() => {
                onProductUnselected?.();
              }}
            >
              {t.products}
            </BackToProducts>
            {t.yourChoise}
          </Title>
          <div>
            <img src={activeProduct?.image} alt="prodcut" />
            <ProductDescription>
              <b>{activeProduct?.title}</b>
              <span>Art-Nr: {activeProduct?.SKU}</span>
              <b>
                <ProductPrice product={activeProduct} />
              </b>
              <span>
                Inkl. {activeProduct?.taxPercent}% MwSt. zzgl. Versandkosten
              </span>
            </ProductDescription>
          </div>
        </Header>
        {selectedProduct?.proboProduct && (
          <ProboOptions
            productCode={selectedProduct.linkedProboProduct}
            loadedOptions={productOptions}
            isLoadedProduct={Boolean(contentType)}
            onOptionsChanged={(rawOptions) => {
              dispatch("product/setProboOptions", rawOptions);
            }}
            onCodesChanged={(proboCodes, proboUploader) => {
              dispatch("product/setProboCodes", proboCodes);
              dispatch("product/setProboUploader", proboUploader);
            }}
          />
        )}
        {!selectedProduct?.proboProduct && (
          <DeskpadOptions
            {...{
              activeProduct,
              selectedProduct,
              products,
              variantLabel,
              selectProduct,
              productVariations,
            }}
          />
        )}
      </div>
      <Params>
        <Summery product={activeProduct} proboOptions={productOptions} />
        <Button
          disabled={
            !activeProduct ||
            (activeProduct.proboProduct && !proboCodes?.length)
          }
          variant="contained"
          color="primary"
          fullWidth
          onClick={async () => {
            activeProduct && dispatch("product/set", activeProduct);
            dispatch("productSelector/close");
            window._paq?.push([
              "trackEvent",
              "ProductSelector",
              "Product selected",
              activeProduct.title,
            ]);
            if (window.tempExistingProducts?.length) {
              const result = await confirm.show({
                text: t.keepCanvas,
                title: t.newCanvasWarnTitle,
              });

              if (result) {
                //TODO: move to a separate functuion
                canvas.renderOnAddRemove = false;
                canvas.stateful = false;
                canvas.loaded = false;
                const objs = canvas
                  ?.getObjects()
                  .filter((obj) => !obj.excludeFromExport);
                objs.forEach((obj) => canvas.remove(obj));
                window.tempExistingProducts.forEach((obj) => canvas.add(obj));
                canvas.renderOnAddRemove = true;
                canvas.stateful = true;
                canvas.loaded = true;
                canvas.DPE.cutZone.fitContent();
                canvas.requestRenderAll();
              }
            }

            if (activeProduct.proboProduct) {
              if (proboUploader.bleed_bottom) {
                canvas.settings.cutSize = proboUploader.bleed_bottom * 10;
              }
              //TOOD: add probo size validation
              canvas.DPE.cutZone.updateSize(
                proboSize.width * 10,
                proboSize.height * 10,
                false,
                true
              );
              canvas.DPE.cutZone.fitCutZone();
              console.group("Probo size");
              console.groupEnd();
            }
            localStorage.setItem("DeskpadEditorProductId", activeProduct.id);
            dispatch("productSelector/close");
          }}
        >
          {t.select}
        </Button>
      </Params>
    </Details>
  );
};
